import React from 'react'
import { Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedExceptionOnlineLoanFraudProps {
  data: any
}

export default function RelatedExceptionOnlineLoanFraud({ data }: RelatedExceptionOnlineLoanFraudProps) {
  const theme = useTheme()
  const categories = [
    { label: '网络小贷欺诈关联', flag: data?.aals_00011 },
    { label: '地方小贷欺诈关联', flag: data?.aals_00012 },
    { label: '消费金融公司欺诈关联', flag: data?.aals_00013 },
    { label: '融资租赁公司欺诈关联', flag: data?.aals_00014 },
    { label: '汽车金融公司欺诈关联', flag: data?.aals_00015 },
    { label: '其他金融公司欺诈关联', flag: data?.aals_00016 },
  ]

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联人网贷欺诈关联
      </Text>
      <div className="mt-3">
        <Table highlightOnHover withColumnBorders={false} verticalSpacing="sm">
          <Table.Thead>
            <Table.Tr>
              <Table.Th>机构类别</Table.Th>
              <Table.Th>结果</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {categories.map((item) => (
              <Table.Tr key={item.label}>
                <Table.Td>{item.label}</Table.Td>
                <Table.Td
                  style={{
                    color: item.flag === 1 ? theme.warningColor : theme.primaryColor,
                    fontWeight: item.flag === 1 ? 600 : 500,
                  }}
                >
                  {item.flag === 1 ? '有' : '无'}
                </Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      </div>
    </div>
  )
}
